import { RouterLink, Image } from '@axilon-apps/libs-ui-components'
import { Button } from '@axilon-apps/libs-ui-shadcn'

import notFoundSvg from '../../assets/not-found.svg'

interface Props {
  href: string
}

const NotFoundPage = ({ href }: Props) => {
  return (
    <main className="flex min-h-full flex-col justify-center py-[100px]">
      <div className="mx-auto w-full max-w-2xl px-4">
        <div className="flex flex-col gap-6">
          <div className="relative h-[200px] md:h-[300px]">
            <Image alt="not found" fill src={notFoundSvg} />
          </div>
          <h1 className="text-foreground text-center text-[56px] font-bold">Not Found.</h1>
          <p className="text-muted-foreground text-center text-xl">
            The page you are trying to access cannot be found or may have been relocated. Kindly
            return to the homepage.
          </p>
          <div className="flex justify-center">
            <Button size="lg" asChild>
              <RouterLink href={href}>Go back home</RouterLink>
            </Button>
          </div>
        </div>
      </div>
    </main>
  )
}

export default NotFoundPage
